module.exports = __webpack_public_path__ + "static/media/contra.622c6e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/contra.png
// module id = 143
// module chunks = 0